import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { showInfoForCallersModal } from '../../../../actions/modal.js';
import { displayGlobalMessage } from 'actions/globalMessage.js';
import Info from '../../info';
import HtmlToReact from 'html-to-react';
import xss from 'xss';

let htmlToReactParser = new HtmlToReact.Parser(React);

export default function SupportContactRightBottomPanel(props) {
  const dispatch = useDispatch();
  const [updatingInformationForCallers, setUpdatingInformationForCallers] = useState(false);

  const closeModal = () => {
    dispatch(showInfoForCallersModal(false));
  };

  const clickSaveBtn = (event) => {
    if (!window.$(event.target).hasClass('disable') && !window.$(event.target.parentNode).hasClass('disable')) {
      saveChanges();
    }
  };

  const saveChanges = () => {
    setUpdatingInformationForCallers(true);

    let cb = (openModal) => {
      //let callback = openModal => {
      setUpdatingInformationForCallers(false);
      dispatch(showInfoForCallersModal(!openModal));
      if (openModal) {
        // Show successful message finally
        dispatch(
          displayGlobalMessage({
            text: APP.LANGUAGE.InformationForCallersModal.SuccessfulMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
      }
    };
    props.saveInformationForCallers(cb);
  };

  let saveClasses =
    props.informationForCallersForm.uploadFileNotAccepted == true
      ? 'ui labeled icon button icon left-text color-button color-button-hover color-white max-width mrlnull mrbnull disable'
      : 'ui labeled icon button icon left-text color-button color-button-hover color-white max-width mrlnull mrbnull';
  return (
    <div>
      {props.updateOrView == 'update' ? (
        <div className="ui actions mrbl max-width">
          <button
            type="button"
            onClick={clickSaveBtn}
            className={updatingInformationForCallers ? saveClasses + ' loading' : saveClasses}
          >
            {APP.LANGUAGE.Save}
            <i className="checkmark  icon" />
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrtm mrlnull mrbnull"
          >
            <i className="remove  icon" />
            {APP.LANGUAGE.Cancel}
          </button>
        </div>
      ) : (
        <div className="ui actions mrbl max-width ">
          <button
            onClick={closeModal}
            className="ui cancel  labeled icon button color-bad-things color-bad-things-hover color-white   max-width left-text mrlnull mrbnull"
          >
            <i className="remove  icon" />
            {APP.LANGUAGE.Close}
          </button>
        </div>
      )}
      <div className="mrtl">
        {props.updateOrView == 'update' ? (
          <div>
            <Info paragraphs={[APP.LANGUAGE.InformationForCallersModal.InfoOnTheRightOne]} />
            <ul>
              <li className="mrtxs color-white-mobile-tablet">
                {APP.LANGUAGE.InformationForCallersModal.InfoOnTheRightTwo}
              </li>
              <li className="mrtxs color-white-mobile-tablet">
                {APP.LANGUAGE.InformationForCallersModal.InfoOnTheRightThree}
              </li>
              <li className="mrtxs color-white-mobile-tablet">
                {APP.LANGUAGE.InformationForCallersModal.InfoOnTheRightFour}
              </li>
              <li className="mrtxs color-white-mobile-tablet">
                {APP.LANGUAGE.InformationForCallersModal.InfoOnTheRightFive}
              </li>
            </ul>
            <p>
              <span className="color-info mrts">
                {htmlToReactParser.parse(xss(APP.LANGUAGE.InformationForCallersModal.InfoOnTheRightSix))}
              </span>
            </p>
            <p>
              <span className="color-info mrts">
                {htmlToReactParser.parse(xss(APP.LANGUAGE.InformationForCallersModal.InfoOnTheRightSeven))}
              </span>
            </p>
          </div>
        ) : (
          <div>
            <Info paragraphs={[APP.LANGUAGE.InformationForCallersModal.InfoOnTheRightOne]} />
            <ul>
              <li className="mrtxs color-white-mobile-tablet">
                {APP.LANGUAGE.InformationForCallersModal.InfoOnTheRightTwo}
              </li>
              <li className="mrtxs color-white-mobile-tablet">
                {APP.LANGUAGE.InformationForCallersModal.InfoOnTheRightThree}
              </li>
              <li className="mrtxs color-white-mobile-tablet">
                {APP.LANGUAGE.InformationForCallersModal.InfoOnTheRightFour}
              </li>
              <li className="mrtxs color-white-mobile-tablet">
                {APP.LANGUAGE.InformationForCallersModal.InfoOnTheRightFive}
              </li>
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}
